import React, { useState, useEffect } from "react";
import { useLocation } from 'react-router-dom';
import { Link } from "react-router-dom";
// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "common/components/MD/MDBox";
import MDButton from "common/components/MD/MDButton";

import MDTypography from "common/components/MD/MDTypography";


// Material Dashboard 2 React example components
import DashboardLayout from "layouts/DashboardLayout";
import DashboardNavbar from "layouts/components/Navbars/DashboardNavbar";
import Footer from "layouts/components/Footer";
import HeaderForm from "layouts/components/HeaderForm";


import Alert from '@mui/material/Alert';

import loading_image from 'common/assets/images/icons/loading-green-loading.gif'


import { ColumnFilter } from "common/components/implemented/Tables/DataTable/ColumnFilter";


import ExpoPartecipazioniService from "services/API/expo_partecipazioni/ExpoPartecipazioniService";
import { NoneFilter } from "../expo_richieste_admin/NoneFilter";


import { useFarFieraUIController } from "common/context/FarFieraContext";
import ExpoDotazioniTable from "./ExpoDotazioniTable";


function ExpoDotazioniList() {

  const [dotazioni, setDotazioni] = useState([]);

  const [ffcontroller] = useFarFieraUIController();
  const { manifestazione} = ffcontroller;

  const [loading, setLoading] = useState(true);


  //per passarmi la variabile se ho salvato e far comparire l'alert
  const location = useLocation();
  const { state } = location != null ? location : { state: { submitted: false, salvato: 'NO', indietro: false } }; // Read values passed on state

  useEffect(() => {

    setDotazioni([]);
    setLoading(true);
    filtra();

  }, [manifestazione]);

  function filtra() {
    console.log("FILTRO CON "+manifestazione);
    ExpoPartecipazioniService.getAllDotazioni(manifestazione)
      .then(response => {
        console.log(response.data);
        setDotazioni(response.data);
        setLoading(false);
      })
      .catch(e => {
        console.log(e);
        setLoading(false);
      });

  }

  

  const ppAttributes = [];

  if (dotazioni.length > 0) {
    dotazioni.forEach(dd => {



      let action = (
        <MDBox>
          {/*
          <Linkd to="/expo_richiestaMessage" state={{ id_proposta: part.id_richiesta0, chiamante: 'expo_partecipazioni_admin' }}
          >
            <MDButton variant="outlined" color={"success"} iconOnly={true}  >
              < AttachEmailIcon />
            </MDButton>   </Link>*/}
          <Link to="/expo_dotazioni_edit" state={{ modo: 'edit', id_soggetto: dd.id_richiesta, chiamante: 'expo_partecipazioni_dotazioni' }}>
            <MDButton variant="outlined" color={"success"} iconOnly={true}>
              <Icon>edit</Icon>
            </MDButton>
          </Link>
        </MDBox>
      );

     

      let val = "NO";
      if (dd.dotazioni_validate) val = "SI";
          let num_prot= dd.protocollo;
if(dd.avi){
  num_prot=dd.protocollo+"A";
}


      ppAttributes.push({
       key:dd.idPartecipazione,
        dd: dd,
        id_partecipazione: dd.idPartecipazione,
        manifestazione: dd.manifetsazione,
        val:val,
        dotazioni_validate:dd.dotazioni_validate,
        protocollo: num_prot,
        azienda: dd.ragione_sociale,
        action: action,
        tot_pa: dd.tot_pa,
        tot_pe: dd.tot_pe+" ["+dd.tot_pe_u+" usati]",
        tot_io: dd.tot_io+" ["+dd.tot_io_u+" usati]",
        tot_ir: dd.tot_ir+" ["+dd.tot_ir_u+" usati]",

        id_richiesta: dd.id_richiesta,
        mq:dd.mq,
        tipologia:dd.tipologia,
      
      })
    });
  }



  const ppTableData = {
    rows: ppAttributes,

    columns: [

      { Header: "Prot.", accessor: "protocollo", Filter: ColumnFilter, width: "5%", align: "left", id: "dotazioni_0" },
      { Header: "Azioni", accessor: "action", Filter: NoneFilter, width: "5%", align: "center", enableGlobalFilter: false, id: "dotazioni_1", disableSortBy: true },
      { Header: "Azienda", accessor: "azienda", Filter: ColumnFilter, align: "left", width: "30%", id: "dotazioni_2" },
        { Header: "Tipologia", accessor: "tipologia", Filter: ColumnFilter, align: "left", id: "dotazioni_3" },
          { Header: "Mq", accessor: "mq", Filter: ColumnFilter, align: "left", width: "5%", id: "dotazioni_4" },
      { Header: "Pass Espositore", accessor: "tot_pe", Filter: ColumnFilter, align: "left", with: "7%", id: "dotazioni_5" },
      { Header: "Pass Auto", accessor: "tot_pa", Filter: ColumnFilter, align: "left", width: "7%", id: "dotazioni_6" },
      { Header: "Riduzioni", accessor: "tot_ir", Filter: ColumnFilter, align: "left", width: "7%", id: "dotazioni_7" },
      { Header: "Omaggi", accessor: "tot_io", Filter: ColumnFilter, width: "7%", align: "left", id: "dotazioni_8" },
      { Header: "Validazione", accessor: "val", Filter: ColumnFilter, width: "7%", align: "left", id: "dotazioni_9" },
    

    ],



  };

  const mypagination = { color: 'success', variant: "contained" };




  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>

          <Grid item xs={12}>
            <Card>
              <HeaderForm titolo={"Dotazioni Espositori " + manifestazione} add="" modo="vis" />
              <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">

                {(state != null && state.submitted && (state.salvato === 'INS' || state.salvato === 'MOD')) &&

                  <Alert severity="success">Dati salvati con successo!</Alert>}

                {(state != null && state.submitted && state.salvato === 'DEL') &&

                  <Alert severity="success">Dati eliminati con successo!</Alert>}
              </MDBox>


              <MDBox pt={3}>
                <ExpoDotazioniTable 
                  table={ppTableData}
                  nome_tabella="dotazioni"
                  isSorted={true}
                  entriesPerPage={true}
                  showTotalEntries={true}
                  pagination={mypagination}
                  noEndBorder
                  responsive={true}
                  first_load={state == null || !state.indietro}
                  filtro_server={true}
                  canExport={true}
                  canSend={true}
                  enableColumnFilters={true}
                  chiamante='expo_dotazioni'
                  filtra={filtra}
                />
              </MDBox>
              {loading &&
                <MDBox opacity={1} textAlign="center">
                  <img src={loading_image} alt="loading" width={100} />
                </MDBox>
              }

              {(dotazioni == null || dotazioni.length === 0) &&
                <MDBox style={{ height: "200px" }} textAlign='center'>
                  <MDTypography
                    variant="button"
                    fontWeight="regular"
                    color="text"
                    sx={{ cursor: "pointer", userSelect: "none", ml: -1 }}
                  >
                    Non ci sono Dotazioni Espositori x la manifestazione selezionata.
                  </MDTypography></MDBox>
              }
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}



export default ExpoDotazioniList;
